import React, { useEffect, useState } from "react";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import tradeColumns from "../../../../columns/trades.jsx";
import { Cookies } from "react-cookie";
import useWebSocket from "react-use-websocket";
import { CloseMT5TradeApi } from "../../../../api/request/liveAccount.js";
import toast from "react-hot-toast";
import { handleApiError } from "../../../../utils/handleApiError.js";

const OpenTrades = ({ loginId }) => {
  const [liveData, setLiveData] = useState([]);
  const cookies = new Cookies();

  const { sendJsonMessage, lastJsonMessage } = useWebSocket(
    `${process.env.REACT_APP_SOCKET_URL}?authorization=Bearer ${cookies.get(
      "token"
    )}`,
    { shouldReconnect: () => true, share: true }
  );

  useEffect(() => {
    sendJsonMessage({
      action: "subscribe",
      eventType: "OpenPosition",
      loginId,
    });
    return () => {
      sendJsonMessage({
        action: "unsubscribe",
        eventType: "OpenPosition",
        loginId,
      });
    };
  }, [loginId]);
  const handleCloseTrade = async (loginId, positionId) => {
    try {
      const payload = {
        loginId: loginId,
        positionId: [positionId],
      };

      const res = await CloseMT5TradeApi(payload);
      if (res?.data?.success) {
        setLiveData((prev) =>
          prev.filter((item) => item.PositionId !== positionId)
        );
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      handleApiError(error);
    }
  };
  useEffect(() => {
    if (lastJsonMessage?.eventType === "OpenPosition") {
      setLiveData(
        lastJsonMessage?.data?.map((item) => ({
          ...item,
          close: (
            <button
              onClick={() => handleCloseTrade(item.Login, item.PositionId)}
            >
              <svg
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
                fill="#D91819"
                className="w-6 h-6 cursor-pointer hover:fill-[#aa0001] duration-500"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill="#D91819"
                    d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
                  ></path>
                </g>
              </svg>
            </button>
          ),
        }))
      );
    }
  }, [lastJsonMessage]);

  return <TableWithSkeleton columns={tradeColumns} data={liveData} />;
};

export default OpenTrades;
